module.exports = __webpack_public_path__ + "img/14.4edeac5d.png";